export default __webpack_public_path__ + "static/media/fb_help1.e392e580.svg";